import { gql } from '@/__generated__';

export const GATE_MESSAGE_RECEIVED = gql(`#graphql
  subscription GateMessageReceived {
    gateMessageReceived {
      id
      movements {
        id
        operatingState
        lastKnownPosition {
          point
          source
          timestamp
        }
        lastBattery
        unit
        precision
        activeMovement {
          ...GateMovementFragment
        }
        lastMovement {
          ...GateMovementFragment
        }
      }
      movement {
        ...GateMovementFragment
      }
      type
      payload
      timestamp
    }
  }
`);
